import React, { Component } from 'react'
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap,playMainMusic} from './PlaySounds';
import {setLanguage} from '../actions/commonActions';

class LanguageScreen extends Component {

      selectLanguage = (lang) => {
        playButtonTap();
        this.props.setLanguage(lang);
        this.props.history.push('/introscreen');
        playMainMusic();
       
      };
    

    render() {
      var pausedText = <div>Select Language <br/><br/><div className = "urdu_font_size"> زبان منتخب کریں</div></div>;
      // if(localStorage.getItem('language') === "ur" ){
      //   pausedText = "زبان منتخب کریں";
      // }else{
      //   pausedText = "Select Language";
      // }
            return(
                <div className = "screen_background">
                  <div className = "buttons_wrapper pause_buttons_wrapper">
                    <div className = "setting_title paused_title">
                      {pausedText}
                    </div>
                    <br/><br/>
                    <img src={"./images/btn_english.png"} alt="" className="button home_button" onClick = {()=>this.selectLanguage("en")}/><br/>
                    <img src={"./images/btn_urdu.png"} alt="" className="button home_button" onClick = {()=>this.selectLanguage("ur")}/><br/>
                  </div>
                  
                </div>
            )
    }
}

LanguageScreen.propTypes = {
  language:PropTypes.string.isRequired,
  setLanguage:PropTypes.func.isRequired
}

const mapStateToProps = state =>({
  language: state.config.language
});

//export default connect(mapStateToProps,{setGameScreenNumber})(PauseScreen);
export default withRouter(connect(mapStateToProps,{setLanguage})(LanguageScreen));



// WEBPACK FOOTER //
// ./src/components/LanguageScreen.js